var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M.232.388A1.11,1.11,0,0,0,.275,1.8l.093.091L7.4,8,.368,14.111.275,14.2a1.11,1.11,0,0,0-.043,1.41.977.977,0,0,0,1.322.223l.1-.079,8-6.954.114-.123.047-.066.058-.1L9.926,8.4l.031-.093.028-.123L10,8.068l0-.1-.01-.12-.018-.1-.025-.092L9.927,7.6l-.053-.117-.053-.089-.1-.125L9.657,7.2l-8-6.956A.977.977,0,0,0,.232.388Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_61",
    "data-name": "Rect\\xE1ngulo 61",
    width: 1680.008,
    height: 9432.009,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_598",
    "data-name": "Grupo 598",
    transform: "translate(16) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    "data-name": "Grupo 58",
    transform: "translate(-1615.007 -2657.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_60",
    "data-name": "Rect\\xE1ngulo 60",
    width: 20,
    height: 26,
    transform: "translate(1610.007 2652.502)",
    fill: "#1d1e1f"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.b468097b.svg";
export { ForwardRef as ReactComponent };